/*Application types*/
export const OIDC_APPLICATION = "OIDC_APPLICATION";
